<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-09"></menubar>
    </div>
    <!--  左メニュー 終了 -->

    <!-- ヘッダー行 開始-->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ $t("title.system.building.title") }}</label>
        <lvory-but
          @click="backSearchbuilding"
          slot="cancel">
            {{ $t("button.common.data.cancel") }}
        </lvory-but>
        <narrow-down
          @click="deviceBatchImport"
          slot="create">
            {{$t('button.common.data.capture')}}
        </narrow-down>
      </head-title>
    </el-row>
    <br>
    <!--   ヘッダー行 終了   -->

    <div slot="body">
      <!-- subtitle -->
      <div class="main-title">
        {{envViewFlag? $t('label.system.building.import.tilte2') : $t('label.system.building.import.tilte')}}
      </div>
      <el-row>
        <el-col>
          <el-form
            label-width="200px"
            label-position="left"
          >
            <el-row>
              <el-col>
                <el-form-item
                  prop="ownerId"
                  size="small"
                  :label="$t('label.system.building.import.file')"
                >
                  <div class="form-group">
                    <index
                      readonly=true
                      :newValue="this.fileName"
                      :placeholderParam="$t('label.system.owner.salesMachine.file')">
                    </index>
                    <selectBtn
                      @click="uploadfile"
                      class="margin-left upload-button-color">
                      {{$t('label.system.owner.salesMachine.fileUpload')}}
                    </selectBtn>
                  </div>
                </el-form-item>

                <input
                  ref="csvUpload"
                  type="file"
                  style="display:none"
                  accept=".csv,.CSV"
                  @change="getCsvfile">

                <el-form-item
                  prop="ownerId"
                  size="small"
                  :label="$t('label.system.building.import.result')"
                >
                  <el-input
                    :readonly="true"
                    id="textarea_result"
                    type="textarea"
                    :autosize="{ minRows: 16, maxRows: 32}"
                    class="in-files-results">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam">
      </el-dialog-prompt>
    </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout"
import SystemManageApi from "@/api/SystemManageApi"
import headTitle from "@/components/common/head/head"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import index from "@/components/common/input/index"
import selectBtn from "@/components/common/generalButton/Select"
import Menubar from "@/components/leftmenu/DashBoard"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
export default {
  components:{
    MainLayout: NewDesignLayout,
    headTitle,
    LvoryBut,
    narrowDown,
    index,
    selectBtn,
    elDialogPrompt,
    menubar: Menubar
  },
  data(){
    return{
      msgParam: "",
      centerDialogVisibleIsShow:false,
      buildingId: null,
      envViewFlag: false,
      query:{
        file:null
      },
      result:{
        successCount:null,
        errorCount:null,
        uploadResult:[{
          lineNo:null,
          message:null
        }]
      },
      resultstr:'',
      fileName:null
    }
  },
  methods:{

    //ファイルを取得
    getCsvfile(){
      let csvFile = this.$refs.csvUpload.files[0]
      var csvCheck = /\.(csv|CSV)$/
      if (!csvCheck.test(csvFile.name)) {
        this.query.file = null
        this.msgParam = this.$t('message.common.validation.fileFormat')
        this.centerDialogVisibleIsShow = true
      } else {
        this.query.file = csvFile
        this.fileName = csvFile.name
      }

      const isLt2M = csvFile.size / 1024 / 1024 < 15;
      if (!isLt2M) {
          this.fileName = null;
          this.$messageIotError(this.$t('message.common.error.ERR_FILE_SIZE_OVER_MSG',{size:'15M'}));
          return this.query.file = null
      }
      if (csvFile.size == 0) {
          this.fileName = null;
          this.$messageIotError(this.$t('message.common.error.ERR_FILE_EMPTY_MSG'));
          return this.query.file = null
      }
    },

    //アップロード入力ボックスを開く
    uploadfile() {
      document.getElementById('textarea_result').value = null
      this.query.file = null
      this.fileName = ''
      this.$refs.csvUpload.value = null
      this.$refs.csvUpload.click()
    },

    //戻る
    backSearchbuilding () {
      this.$router.push({
        name:"system-building-manage-menu",
        params: {
          buildingId: this.buildingId,
        },
      })
    },

    deviceBatchImport(){
      if(this.query.file == null){
        this.msgParam = this.$t('message.common.validation.required', {
          field: this.$t('label.system.owner.salesMachine.file')
        })
        this.centerDialogVisibleIsShow = true
      }else{
        SystemManageApi.deviceBatchImport({
        csvFile: this.query.file,
        },this.envViewFlag)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if(!statusErrorCodeMsg(data.statusCode, this)) {
            return this.query.file = null;
          }
          if (data.body.failureCount > 0) {
              this.resultstr = this.$t('message.common.csvImport.ERR_FAILURE_MSG');
          } else {
              this.resultstr = this.$t('message.common.csvImport.INFO_SUCCESS_AMOUNT_MSG',{amount:data.body.successCount});
          }
          for (let i = 0; i < data.body.failureDetails.length; i++) {
              let failureDetail = data.body.failureDetails[i]
              this.resultstr = this.resultstr + "\r\n" + this.$t('message.common.csvImport.ERR_' + failureDetail.message + "_MSG",
                      {row:failureDetail.lineNo,
                      column:failureDetail.itemIndex
                      });
            }
            document.getElementById('textarea_result').value = this.resultstr
        })
      }
    }

  },
  created(){
    this.buildingId = this.$route.params.buildingId;
    this.envViewFlag = this.$route.params.envViewFlag;
    this.$authCheck("010305")

     let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/buildings/search",
        title: "label.router.building",
      },
      {
        path: "",
        title: "label.router.detailBuilding",
      },
      {
        path: "",
        title: this.envViewFlag? "label.router.envViewDeviceImport" : "label.router.buildingDeviceImport",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
.margin-left{
  margin-left: 20px;
}
::v-deep input::-webkit-input-placeholder {
  font-size: 14px;
  color: #B8B8B4;
}
.font-top{
  position: relative;
  top: 11px;
}
/* No.130 start */
::v-deep .el-form-item__content{
  position: absolute;
  margin-left: 140px !important;
}
::v-deep .el-textarea__inner{
  min-height:237px !important;
  height: 237px !important;
  width: 596px !important;
  background-color: #DEDED9 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}
::v-deep .el-form-item--small .el-form-item__label {
  height: 44px;
  line-height: 44px;
}
.in-files-results {
  margin-top: 8px;
}
.upload-button-color {
  ::v-deep .my-button {
    background-color: #F7F7F2 !important;
  }
}
/* No.130 end */
</style>
